import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'

@createActions(alt)
export default class GlobalErrorActions {
  constructor() {
    this.generateActions(
      'setGlobalError',
      'clearGlobalError'
    );
  }

  setGenericGlobalError() {
    this.setGlobalError("There's been an error. Please refresh the page to try again.")
  }
}



// WEBPACK FOOTER //
// ./app/actions/GlobalErrorActions.js